class Monitoring.Methods.XhrControl

  constructor: (xhr) ->
    @xhr = xhr || window.XMLHttpRequest || window.ActiveXObject

  shutdown: ->
    # do nothing: disables all ajax calls
    @xhr.prototype.send = ->

  handle: (xhr) ->
    return unless (xhr && xhr.status == 401)
    @shutdown()
    message = I18n.t('unauthorized.new_login')
    swal({
      title: message
      type: 'warning'
      closeOnConfirm: true
      confirmButtonText: 'Ok'
    }, (isConfirm) => window.location.reload())

window.XhrControl = new Monitoring.Methods.XhrControl()
